// "Report to compliance" intake — typed mirrors of
// ComplianceIntakeReportDtos.cs. Status / severity / category string
// vocabularies mirror Core.Entities.Compliance (ComplianceIntakeReport-
// Statuses / -Severities / -Categories) — keep in sync with the backend.

export type ComplianceIntakeReportStatus =
  | "New"
  | "Acknowledged"
  | "Investigating"
  | "Resolved"
  | "Escalated";

/** Triage signal only — deliberately NOT the ComplianceSeverity cure-SLA
 *  vocabulary (see the entity's doc comment). */
export type ComplianceIntakeReportSeverity = "Minor" | "Major" | "Critical";

export const COMPLIANCE_REPORT_SEVERITIES: ComplianceIntakeReportSeverity[] = [
  "Minor",
  "Major",
  "Critical",
];

/** Server-validated category list (values are the display strings). */
export const COMPLIANCE_REPORT_CATEGORIES = [
  "Vendor non-performance",
  "Borrower non-compliance",
  "Financial reporting",
  "Insurance",
  "UCC / collateral",
  "Documentation",
  "Other",
] as const;

export type ComplianceIntakeReportCategory =
  (typeof COMPLIANCE_REPORT_CATEGORIES)[number];

export interface ComplianceIntakeReportDto {
  id: string;
  loanId: string;
  category: string;
  description: string;
  suggestedSeverity: ComplianceIntakeReportSeverity | null;
  triageSeverity: ComplianceIntakeReportSeverity | null;
  status: ComplianceIntakeReportStatus;
  reportedByUserId: string;
  reportedByUserName: string | null;
  reportedAt: string;
  acknowledgedAt: string | null;
  resolvedAt: string | null;
  resolutionReason: string | null;
  escalatedDefaultCaseId: string | null;
  documentId: string | null;
  source: string;
}

export interface CreateComplianceIntakeReportRequest {
  category: string;
  description: string;
  suggestedSeverity?: ComplianceIntakeReportSeverity | null;
  documentId?: string | null;
}

/** Null triageSeverity = unchanged (FIND-12 — the triage forms hydrate the
 *  current value and always send it). */
export interface TriageComplianceIntakeReportRequest {
  triageSeverity?: ComplianceIntakeReportSeverity | null;
}

export interface ResolveComplianceIntakeReportRequest {
  reason: string;
}

export interface EscalateComplianceIntakeReportRequest {
  triggerDate: string;
  description: string;
}
